module.exports = __webpack_public_path__ + "static/media/web04_jpn.69d541a2.png";